import { css } from 'styled-components';
import BREAKPOINTS from '../breakpoints';
const BREAKPOINTSKEYS = Object.keys(BREAKPOINTS);
const BREAKPOINTSMAP = new Map(Object.entries(BREAKPOINTS));

export const media: { [key: string]: (literals: TemplateStringsArray, ...args: any[]) => string } = BREAKPOINTSKEYS.reduce((acc: {}, label: string, idx: number) => {
  acc[`${label}min`] = (literals: TemplateStringsArray, ...args: any[]): any => css`
    @media screen and (min-width: ${BREAKPOINTS[label]}) {
      ${css(literals, ...args)};
    }
  `;

  acc[`${label}max`] = (literals: TemplateStringsArray, ...args: any[]): any => {
    const nextBreakPoint  = BREAKPOINTSKEYS[idx + 1];
    if (nextBreakPoint) {
      const ceiling = parseInt(BREAKPOINTSMAP.get(nextBreakPoint), 10) - 1;
      return css`
        @media screen and (max-width: ${ceiling}px) {
          ${css(literals, ...args)};
        }
      `;
    }
  };

  acc[`${label}strict`] = (literals: TemplateStringsArray, ...args: any[]): any => {
    const nextBreakPoint  = BREAKPOINTSKEYS[idx + 1];
    if ( nextBreakPoint ) {
      const ceiling = parseInt(BREAKPOINTSMAP.get(nextBreakPoint), 10) - 1;
      const query = css`
        @media only screen and (min-width: ${BREAKPOINTS[BREAKPOINTSKEYS[idx]]}) and (max-width: ${ceiling}px) {
        ${css(literals, ...args)};
        }
      `;
      return query;
    } else {
      return css`
        @media screen and (min-width: ${BREAKPOINTS[label]}) {
          ${css(literals, ...args)};
        }
      `;
    }
  };

  return acc;
}, {});
